/** The SDK keeps the composer editable while its send button switches to stop. */
export function isBookingReplyPending(input?: HTMLTextAreaElement): boolean {
  return Boolean(
    input
      ?.closest('[data-gengage-part="chat-input-area"]')
      ?.querySelector('[data-gengage-part="chat-send"].gengage-chat-send--stop')
  );
}

/** Shared styling for optional booking controls, including shadow-root widgets. */
export function styleBookingPicker(form: HTMLFormElement): void {
  form.classList.add('otokoc-picker');
  const style = document.createElement('style');
  style.textContent = `
    .otokoc-picker { box-sizing:border-box; flex:0 1 44%; min-width:116px; max-width:240px; margin:0; padding:0; border:0; color:#142d50; font:14px/1.4 "Segoe UI",system-ui,sans-serif; transition:flex-basis .16s ease,max-width .16s ease,min-width .16s ease; }
    [data-otokoc-picker-mode] { gap:0!important; padding:5px 10px 5px 6px!important; align-items:center!important; border:1px solid #dce4ef!important; box-shadow:none!important; outline:none!important; }
    [data-otokoc-picker-mode=select] { padding:0!important; border-color:transparent!important; background:transparent!important; box-shadow:none!important; }
    [data-otokoc-picker-mode] [data-gengage-part="chat-send"] { flex:0 0 40px!important; margin-left:4px!important; }
    [data-otokoc-picker-mode] [data-gengage-part="chat-send"]:not(:disabled):not(.gengage-chat-send--stop) { background:#0f2b5b!important; color:#fff!important; }
    [data-otokoc-picker-mode] [data-gengage-part="chat-input"] { display:block!important; flex:1 1 8rem!important; min-width:72px!important; padding-left:12px!important; }
    [data-otokoc-picker-mode=select] textarea[data-gengage-part="chat-input"] { display:none!important; }
    [data-otokoc-picker-mode=select] [data-gengage-part="chat-attachment-button"] { display:none!important; }
    [data-otokoc-picker-mode=select] .otokoc-picker { flex:1 1 auto; min-width:0; max-width:none; margin-left:0; }
    [data-otokoc-picker-mode=select] .otokoc-picker-label { position:relative; }
    [data-otokoc-picker-mode=select] .otokoc-picker-label::after { content:none; }
    [data-otokoc-picker-mode=select] .otokoc-picker-control { min-height:42px; padding:9px 12px; border-color:#dce4ef; border-radius:22px; background:#fff; box-shadow:none; }
    [data-otokoc-picker-mode=select] .otokoc-picker-control>span { display:block; min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    [data-otokoc-picker-mode=select] .otokoc-picker-control:focus-visible,[data-otokoc-picker-mode=select] .otokoc-picker-control[aria-expanded=true] { border-color:#9fb0c9; background:#fff; box-shadow:0 0 0 3px #0f2b5b12; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] { flex:1 1 auto; min-width:0; max-width:none; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] + textarea[data-gengage-part="chat-input"] { display:none!important; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] .otokoc-picker-fields { grid-template-columns:minmax(120px,1fr) minmax(88px,.68fr); gap:6px; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] .otokoc-picker-control { padding-inline:12px; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] .otokoc-picker-label:first-child::before { content:''; position:absolute; top:50%; right:18px; z-index:1; width:16px; height:16px; box-sizing:border-box; border:1.7px solid #0f2b5b; border-radius:4px; background:linear-gradient(#0f2b5b,#0f2b5b) 3px 5px/8px 1.7px no-repeat,#fff; transform:translateY(-50%); pointer-events:none; opacity:.88; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] input.otokoc-picker-control { padding-right:42px; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] input.otokoc-picker-control::-webkit-calendar-picker-indicator { width:24px; margin-right:12px; opacity:0; }
    [data-otokoc-picker-mode=select] .otokoc-picker[data-otokoc-booking-datetime] .otokoc-picker-control>span { white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    [data-otokoc-picker-mode=text] { min-height:52px!important; border-radius:28px!important; }
    [data-otokoc-picker-mode=text] textarea[data-gengage-part="chat-input"] { height:40px!important; min-height:24px!important; max-height:40px!important; overflow-y:auto!important; resize:none!important; color:#151c25!important; caret-color:auto!important; font-size:16px!important; line-height:1.35!important; }
    [data-otokoc-picker-mode=text] .otokoc-picker { align-self:center!important; flex:0 0 44px; width:44px; min-width:44px; max-width:44px; height:44px; overflow:visible; }
    [data-otokoc-picker-mode=text] .otokoc-picker-fields { display:flex; gap:0; }
    [data-otokoc-picker-mode=text] .otokoc-picker-label:not(:first-child) { display:none!important; }
    [data-otokoc-picker-mode=text] .otokoc-picker-label { width:44px; height:44px; }
    [data-otokoc-picker-mode=text] .otokoc-picker-control { width:44px; min-height:44px; height:44px; padding:0; justify-content:center; }
    [data-otokoc-picker-mode=text] .otokoc-picker-control>span { max-width:0; opacity:0; overflow:hidden; }
    [data-otokoc-picker-mode=text] input.otokoc-picker-control { color:transparent; font-size:0; }
    .otokoc-picker-mode { display:flex; align-items:center; justify-content:center; flex:0 0 34px; width:34px; height:40px; margin-left:4px; padding:7px; border:0; border-radius:999px; background:transparent; color:#63748c; cursor:pointer; }
    .otokoc-picker-mode[hidden] { display:none!important; }
    .otokoc-picker-mode svg { width:19px; height:19px; }
    .otokoc-picker-mode:focus-visible { outline:2px solid #6785b3; }
    .otokoc-picker-fields { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:10px; }
    .otokoc-picker-label { display:block; min-width:0; color:#63748c; font-size:12px; font-weight:600; }
    .otokoc-picker-control { box-sizing:border-box; display:flex; align-items:center; justify-content:space-between; gap:10px; width:100%; min-width:0; min-height:48px; padding:11px 12px; border:1px solid #dce4ef; border-radius:22px; background:#fff; color:#17345c; font:500 14px/1.4 "Segoe UI",system-ui,sans-serif; text-align:left; cursor:pointer; transition:border-color .15s,box-shadow .15s; }
    .otokoc-picker-control>span { white-space:normal; overflow-wrap:anywhere; }
    .otokoc-picker-control:not(input)::after { content:''; flex-shrink:0; width:6px; height:6px; margin:0 2px 3px 0; border-right:1.5px solid #7b8ba2; border-bottom:1.5px solid #7b8ba2; transform:rotate(45deg); }
    .otokoc-picker-control:hover:not(:disabled) { border-color:#9daec6; }
    .otokoc-picker-control:focus-visible,.otokoc-picker-control[aria-expanded=true] { outline:none; border-color:#6785b3; box-shadow:0 0 0 3px #0f2b5b12; }
    .otokoc-picker-control:disabled { background:#f1f4f8; color:#96a2b5; cursor:default; }
    .otokoc-picker-control[data-empty=true] { color:#8290a5; font-weight:400; }
    input.otokoc-picker-control { font-size:16px; }
    .otokoc-picker-note { margin:10px 0 12px; color:#7b8798; font-size:11px; line-height:1.5; }
    .otokoc-picker-menu { position:fixed; box-sizing:border-box; margin:0; padding:6px; border:1px solid #dce4ef; border-radius:22px; background:#fff; color:#17345c; box-shadow:0 12px 40px #0f2b5b26; overflow-y:auto; overscroll-behavior:contain; font:14px/1.4 "Segoe UI",system-ui,sans-serif; }
    .otokoc-picker-option { display:flex; align-items:center; justify-content:space-between; gap:12px; min-height:44px; box-sizing:border-box; padding:10px 12px; border-radius:16px; overflow-wrap:anywhere; cursor:pointer; }
    .otokoc-picker-option[data-active=true] { background:#f0f4fa; }
    .otokoc-picker-option[aria-selected=true] { color:#0f2b5b; background:#eaf0fa; font-weight:600; }
    @media (max-width:360px) { .otokoc-picker-fields { grid-template-columns:minmax(0,1fr); } }
    .otokoc-picker-option[aria-selected=true]::after { content:'✓'; flex-shrink:0; }
  `;
  form.prepend(style);
}

export interface BookingSelectOption {
  id: string;
  name: string;
}
let selectSequence = 0;

/** Select-only combobox: focus stays on the trigger; popup lives in the top layer. */
export function createBookingSelect(name: string, onChange: () => void) {
  const element = document.createElement('div');
  element.className = 'otokoc-picker-label';
  let fieldName = name;
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'otokoc-picker-control';
  button.setAttribute('role', 'combobox');
  button.setAttribute('aria-label', name);
  button.setAttribute('aria-haspopup', 'listbox');
  button.setAttribute('aria-expanded', 'false');
  const text = document.createElement('span');
  button.append(text);
  const menu = document.createElement('div');
  menu.className = 'otokoc-picker-menu';
  menu.id = `otokoc-picker-options-${++selectSequence}`;
  menu.setAttribute('role', 'listbox');
  menu.setAttribute('aria-label', name);
  menu.setAttribute('popover', 'manual');
  button.setAttribute('aria-controls', menu.id);
  element.append(button, menu);
  let options: BookingSelectOption[] = [];
  let value = '';
  let active = 0;
  let open = false;
  let prefix = '';
  let lastKeyTime = 0;
  const renderValue = () => {
    text.textContent = options.find((option) => option.id === value)?.name ?? `${fieldName} seçin`;
    button.dataset.empty = String(!value);
  };
  const highlight = () => {
    Array.from(menu.children).forEach((node, index) => {
      const item = node as HTMLElement;
      item.dataset.active = String(index === active);
      item.setAttribute('aria-selected', String(options[index].id === value));
    });
    if (open && options[active]) {
      button.setAttribute('aria-activedescendant', `${menu.id}-${active}`);
      menu.children[active]?.scrollIntoView({ block: 'nearest' });
    }
  };
  const outside = (event: Event) => {
    if (!event.composedPath().includes(button) && !event.composedPath().includes(menu)) close();
  };
  const close = () => {
    if (!open) return;
    open = false;
    menu.hidePopover();
    button.setAttribute('aria-expanded', 'false');
    button.removeAttribute('aria-activedescendant');
    window.removeEventListener('pointerdown', outside, true);
    window.removeEventListener('resize', close);
  };
  const show = () => {
    if (button.disabled || !options.length || open) return;
    const rect = button.getBoundingClientRect();
    const width = Math.min(Math.max(rect.width, 260), window.innerWidth - 24);
    const above = rect.top > window.innerHeight - rect.bottom;
    menu.style.width = `${width}px`;
    menu.style.left = `${Math.max(12, Math.min(rect.left, window.innerWidth - width - 12))}px`;
    menu.style.maxHeight = `${Math.min(280, Math.max(100, (above ? rect.top : window.innerHeight - rect.bottom) - 20))}px`;
    menu.style.top = above ? 'auto' : `${rect.bottom + 8}px`;
    menu.style.bottom = above ? `${window.innerHeight - rect.top + 8}px` : 'auto';
    menu.showPopover();
    open = true;
    active = Math.max(
      0,
      options.findIndex((option) => option.id === value)
    );
    button.setAttribute('aria-expanded', 'true');
    highlight();
    window.addEventListener('pointerdown', outside, true);
    window.addEventListener('resize', close);
  };
  const choose = (index: number) => {
    if (!options[index]) return;
    value = options[index].id;
    close();
    renderValue();
    button.focus({ preventScroll: true });
    onChange();
  };
  button.addEventListener('click', () => (open ? close() : show()));
  button.addEventListener('blur', close);
  menu.addEventListener('pointerdown', (event) => event.preventDefault());
  menu.addEventListener('click', (event) => {
    const item = (event.target as HTMLElement).closest<HTMLElement>('[data-option-index]');
    if (item) choose(Number(item.dataset.optionIndex));
  });
  button.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      event.stopPropagation();
      close();
      return;
    }
    if (event.key === 'Tab') {
      close();
      return;
    }
    if (['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      if (open) choose(active);
      else show();
      return;
    }
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      if (!open) {
        show();
        return;
      }
      active =
        event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? options.length - 1
            : Math.max(
                0,
                Math.min(options.length - 1, active + (event.key === 'ArrowDown' ? 1 : -1))
              );
      highlight();
    } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
      event.preventDefault();
      show();
      const now = Date.now();
      prefix = (now - lastKeyTime < 700 ? prefix : '') + event.key.toLocaleLowerCase('tr');
      lastKeyTime = now;
      const index = options.findIndex((option) =>
        option.name.toLocaleLowerCase('tr').startsWith(prefix)
      );
      if (index >= 0) {
        active = index;
        highlight();
      }
    }
  });
  renderValue();
  return {
    element,
    button,
    get value() {
      return value;
    },
    set value(next: string) {
      value = next;
      renderValue();
    },
    get disabled() {
      return button.disabled;
    },
    set disabled(next: boolean) {
      if (button.disabled !== next) button.disabled = next;
      if (next) close();
    },
    setOptions(next: BookingSelectOption[], nextName = name) {
      close();
      fieldName = nextName;
      button.setAttribute('aria-label', nextName);
      menu.setAttribute('aria-label', nextName);
      options = next;
      value = '';
      menu.replaceChildren(
        ...options.map((option, index) => {
          const item = document.createElement('div');
          item.className = 'otokoc-picker-option';
          item.id = `${menu.id}-${index}`;
          item.dataset.optionIndex = String(index);
          item.setAttribute('role', 'option');
          item.textContent = option.name;
          return item;
        })
      );
      renderValue();
      highlight();
    },
    close,
  };
}
